import React, { useEffect, useContext, useMemo, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import PropTypes from 'prop-types'
import { DraftContext, HelperContext } from './ContextProvider'
import Header from './Header'
import Warn from './Warn'
import RegenerateModal from './RegenerateModal'
import GPTHelper from './GPTHelper'
import TranslateComponent from './Translate'
import ReGPTHelper from './ReGPTHelper'

function AppWrapper({ children }) {
  const navigate = useNavigate()
  const location = useLocation()
  const {
    draftId,
    showWarn,
    setShowWarn,
    showGen,
    setShowGen,
    currentID,
    touched,
    settouched,
  } = useContext(DraftContext)
  const { helper } = useContext(HelperContext)
  const [placeholder, setPlaceholder] = useState('')
  const [file, setFile] = useState(null)
  useEffect(() => {
    switch (currentID) {
      case 1:
      case 2:
        setPlaceholder('我想分析 [市場] 的 [產業/服務]')
        break
      case 3:
      case 4:
        setPlaceholder(
          '經常 [描述行為特徵] 的 [角色/職業]，想要 [達成什麼目標/任務]'
        )
        break
      default:
    }
  }, [currentID])
  const isInDraft = useMemo(
    () =>
      [
        '/module1',
        '/module2/product',
        '/module2/matrix',
        '/module2/design',
        '/module2/weak',
        '/module2/inovation',
        '/module3',
        '/module4',
        '/Module1',
        '/Module3',
        '/Module4',
      ].includes(location.pathname),
    [location]
  )

  const unGpt = useMemo(
    () =>
      ['login', '/', 'register', 'edit_password', 'forget_password'].indexOf(
        location.pathname
      ) > -1,
    [location.pathname]
  )

  const handleChange = (e) => {
    setFile(e)
  }

  useEffect(() => {
    if (draftId && !isInDraft) {
      navigate('/module1')
    } else if (!draftId && isInDraft) {
      navigate('/list')
    }
  }, [draftId])

  const isEdit = useMemo(
    () => ['/module1'].includes(location.pathname),
    [location]
  )
  console.log(showGen)

  return (
    <div id="wrapper" className={isInDraft ? 'edit' : ''}>
      {!isEdit && <Header />}
      <TranslateComponent />
      <div
        id="main"
        onClick={() => {
          if (!touched) settouched(true)
        }}
        aria-hidden
      >
        {children}
      </div>
      <Warn
        setting={{
          show: showWarn.show,
          text: showWarn.text,
          icon: '',
          handleConfirm: () => {
            showWarn.func()
          },
          handleClose: () => {
            setShowWarn({ ...showWarn, show: false })
          },
        }}
      />
      <RegenerateModal
        setting={{
          show: showGen.show,
          handleConfirm: showGen.func,
          btnText: showGen.btnText,
          handleClose: () => {
            setShowGen({
              ...showGen,
              show: false,
              isToolBarBtn: false,
              titleLabel: '',
              placeholder: '',
            })
          },
          placeholder: showGen?.placeholder || placeholder,
          handleChange,
          file,
          titleLabel: showGen?.titleLabel || '分析面向',
          isToolBarBtn: showGen?.isToolBarBtn || false,
        }}
      />
      {!unGpt && !helper.show && <GPTHelper setting={{}} />}
      {helper.show && <ReGPTHelper setting={{}} />}
    </div>
  )
}

AppWrapper.propTypes = {
  children: PropTypes.shape().isRequired,
}

export default AppWrapper
